// extracted by mini-css-extract-plugin
module.exports = {"hstack":"HStack_hstack__LZCO2","center":"HStack_center__2lzTB","right":"HStack_right__2nlSi"};